export default "__VITE_ASSET__4189e345__"